/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreApproveVacationPaymentDto } from '../../models/core-approve-vacation-payment-dto';
import { CoreMessageResponseDto } from '../../models/core-message-response-dto';

export interface VacationBillingControllerApproveVacationPayment$Params {
  tenant: string;

/**
 * Project ID
 */
  id: string;
      body: CoreApproveVacationPaymentDto
}

export function vacationBillingControllerApproveVacationPayment(http: HttpClient, rootUrl: string, params: VacationBillingControllerApproveVacationPayment$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreMessageResponseDto>> {
  const rb = new CoreRequestBuilder(rootUrl, vacationBillingControllerApproveVacationPayment.PATH, 'post');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<CoreMessageResponseDto>;
    })
  );
}

vacationBillingControllerApproveVacationPayment.PATH = '/o2-core/projects/{tenant}/{id}/approve-vacation-payment';
